export const getAnimationDuration = (element: Element | undefined, window: Window): number => {
    const elementHeight = element?.clientHeight || 0;
    const windowHeight = window.innerHeight;

    return Math.max(windowHeight, elementHeight);
};
